<sw-page class="xps-product-finder-list">
    <template #search-bar>
        <sw-search-bar
            initial-search-type="xps_product_finder"
            :placeholder="$tc('xps-product-finder.list.placeholderSearchBar')"
            :initial-search="searchTerm"
            @search="onSearch">
        </sw-search-bar>
    </template>

    <template #smart-bar-header>
        <h2>
            {{ $tc('xps-product-finder.list.title') }}
            <span v-if="!isLoading" class="sw-page__smart-bar-amount">
                ({{ total }})
            </span>
        </h2>
    </template>

    <template #smart-bar-actions>
        <mt-button
            variant="primary"
            @click="$router.push({ name: 'xps.product.finder.create' })">
            {{ $tc('xps-product-finder.list.buttonAddProductFinder') }}
        </mt-button>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="productFinders"
            :items="productFinders"
            :repository="repository"
            :showSelection="true"
            :columns="columns"
            :fullPage="true"
            :sortBy="sortBy"
            :sortDirection="sortDirection"
            :isLoading="isLoading"
            @page-change="onPageChange"
            @column-sort="onSortColumn"
            @inline-edit-save="onInlineEditSave"
            @item-edit="onEdit">

            <template #column-active="{ item }">
                <mt-icon
                    v-if="item.active"
                    name="regular-checkmark"
                    size="16px"
                    class="is--active">
                </mt-icon>
                <mt-icon
                    v-else
                    name="regular-times"
                    size="16px"
                    class="is--inactive">
                </mt-icon>
            </template>

            <template #actions="{ item }">
                <sw-context-menu-item
                    class="xps-product-finder-list__edit-action"
                    :router-link="{ name: 'xps.product.finder.detail', params: { id: item.id } }">
                    {{ $tc('xps-product-finder.list.contextMenuEdit') }}
                </sw-context-menu-item>

                <sw-context-menu-item
                    variant="danger"
                    @click="onDelete(item.id)">
                    {{ $tc('xps-product-finder.list.contextMenuDelete') }}
                </sw-context-menu-item>
            </template>
        </sw-entity-listing>

        <sw-empty-state
            v-if="!isLoading && !total"
            :title="$tc('xps-product-finder.list.messageEmpty')">
        </sw-empty-state>
    </template>
</sw-page>
